export default {"src":"/_next/static/media/_iconBook.aff7b2f1.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};